// Check if mock data is enabled
const useMockData = process.env.REACT_APP_USE_MOCK_DATA === 'true';

// Get the API URL from environment or use a default
const getApiUrl = () => {
  return process.env.REACT_APP_RSVP_API_ENDPOINT ||
    "https://your-api-gateway-url.execute-api.us-east-1.amazonaws.com/prod";
};

export const apiService = {
  async getRegistry() {
    if (useMockData) {
      console.log('🔧 Mock mode enabled - please use Storybook for development');
      throw new Error('Mock mode enabled. Use Storybook for component development.');
    }

    console.log('🌐 Fetching registry from API');
    const apiUrl = getApiUrl();
    const response = await fetch(`${apiUrl}/registry`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  },

  async updateRegistryItem(itemId: string, isPurchased: boolean, purchasedBy: string, trackingLink?: string) {
    if (useMockData) {
      console.log('🔧 Mock mode enabled - please use Storybook for development');
      throw new Error('Mock mode enabled. Use Storybook for component development.');
    }

    console.log('🌐 Updating registry item via API');
    const apiUrl = getApiUrl();
    const response = await fetch(`${apiUrl}/registry`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        item_id: itemId,
        is_purchased: isPurchased,
        purchased_who: purchasedBy,
        tracking_link: trackingLink,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  },

  async pledgeRegistryItem(itemId: string, pledgerName: string, amount: number) {
    if (useMockData) {
      console.log('🔧 Mock mode enabled - please use Storybook for development');
      throw new Error('Mock mode enabled. Use Storybook for component development.');
    }

    console.log('🌐 Adding pledge via API');
    const apiUrl = getApiUrl();
    const response = await fetch(`${apiUrl}/registry/pledge`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        item_id: itemId,
        pledger_name: pledgerName,
        amount: amount,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }
};

// Export utility functions
export const getApiMode = () => useMockData ? 'mock' : 'live';
export const setMockMode = (enabled: boolean) => {
  if (enabled) {
    localStorage.setItem('REACT_APP_USE_MOCK_DATA', 'true');
  } else {
    localStorage.removeItem('REACT_APP_USE_MOCK_DATA');
  }
  window.location.reload(); // Reload to apply changes
};
